/* Component in the edit page to display and edit the Callsheet 
   Background items 
 * Contains the BackgroundInfo component to display 
   the extra background info 
 * Contains the BgInfoMob component to display 
   the extra background info in mobile */
import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../../styles/Callsheets.module.css";
import btnStyles from "../../../styles/Button.module.css";
// eslint-disable-next-line
import { Button } from 'react-bootstrap';
import { PostDropdown } from '../../../components/PostDropdown';
import { axiosInstance, axiosReq } from '../../../api/axiosDefaults';
import BackgroundInfo from './BackgroundInfo';
import EditBack from '../CallsheetEditBackGround';
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config"
import useHostName from "../../../hooks/useHostName"
import { useCurrentUser } from "../../../contexts/CurrentUserContext"
import toast from "react-hot-toast";

const BackgroundAddBG = (props) => {
    const host = useHostName()
    const [showInfo, setShowInfo] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const currentUser = useCurrentUser();

    const { id, day_id, qty, type, call, scenes, set, costumes,
        style, handleMount} = props

    const [bgNew, setBgNew] = useState({
        id1: id,
        day_id1: day_id,
        qty1: qty,
        type1: type,
        call1: call,
        scenes1: scenes,
        set1: set,
        costumes1: costumes,
    });

    const { id1, qty1, type1, call1, } = bgNew;

    const handleEdit = () => {
        setShowEdit(showEdit => !showEdit)
      };
    
    const handleDelete = async () => {
        try {
          if (host === CLIENT_PROGRAM_HOSTNAME) {
            await axiosReq.delete(`/backgroundcallsnew/${id1}/`)
            handleMount();
            toast.success(`Background Deleted`);
          } else {
            await axiosInstance.delete(
              `${localStorage.getItem("projectSlug")}/backgroundcallsnew/${id1}/`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
                withCredentials: true,
              }
            )
            handleMount();
            toast.success(`Background Deleted`);
          }
        } catch (err) { }
      }

  return (
    <div style={style} >
        <div>
        <Row className='text-center mx-0 mt-2 mt-md-0' >
            <Col className={`mx-0 px-0 `} xs={1} md={1}>
                <div className={`mb-0 ${styles.Border2}`}>
                <PostDropdown
                        className={` mx-0 my-2`}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                    />
                    </div>
                </Col>   
            <Col className={`mx-0 px-0 py-1 d-flex align-items-center justify-content-center ${styles.Border2}`} xs={2} md={2}>
                <p className={` ${styles.Bold}`}>{qty1}</p>
            </Col>
            <Col className={`mx-0 px-0 py-1 d-flex align-items-center justify-content-center ${styles.CastCall}`} xs={2} md={2}>
                <p className={` ${styles.Bold}`}>{call1}</p>
            </Col>
            <Col className={`mx-0 px-0 py-1 d-flex align-items-center justify-content-center ${styles.Border2}`} xs={5} md={5}>
            <p className={` ${styles.Bold}`}>{type1}</p>
            </Col>
            <Col className={`mx-0 px-0 py-1 d-flex align-items-center justify-content-center ${styles.Border2} `} xs={2} md={2}>
            <Button onClick={() => setShowInfo(showInfo => !showInfo)} 
                className={`${btnStyles.Button} ${btnStyles.Shed}`}>
                I
            </Button>
            </Col>
        </Row>
        {/* info */}
        <Row>
            <Col>
                {!showInfo ?("") : (                       
                <BackgroundInfo {...bgNew}/> 
                ) }
            </Col>
        </Row>
        <Row>
          {!["Cast", "Crew", "Admincreative"].includes(currentUser?.groups[0]?.name) && <Col>
            {!showEdit ? (
              ""
            ) : (
              <EditBack
                setBgNew={setBgNew}
                setShowEdit={setShowEdit}
                {...bgNew}
              />
            )}
          </Col>}
        </Row>
        </div>
    </div>
  )
}

export default BackgroundAddBG